var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"h-60px hover:bg-gray_f6f",on:{"click":function($event){return _vm.clickRow(_vm.row)}}},_vm._l((_vm.columns),function(column){return _c('TableCell',{key:column.id,attrs:{"row":_vm.row,"column":column}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }